<div class="w-full">
  <div class="flex flex-col text-sm md:portrait:text-sm md:landscape:text-[8px] md:landscape:leading-[12px] md2:landscape:text-[10px] md2:landscape:leading-[15px] md4:landscape:text-xs mlg:landscape:text-sm border-2 border-lighterText lg:mb2 rounded-2xl py-1 xl:py-2 px-2 xl:px-4 w-full">
    <div class="flex flex-col md:flex-row gap-4 min-h-0">
      <div class="w-full md:landscape:w-[80%] md:portrait:w-[75%] lg:w-[75%] flex flex-col">
        <span class="font-semibold text-base md:portrait:text-base md:landscape:text-[10px] md:landscape:leading-[15px] md2:landscape:text-[11px] md2:landscape:leading-[16px] md4:landscape:text-sm mlg:text-base xl:mb-1">
          1/3: KOMMUNIKATION
        </span>
        <span>
          Ich willige ein, von {{ brand.name.toUpperCase() }} über die aufgeführten Kanäle Mitteilungen
          zu meinen Interessen und Präferenzen zu erhalten.
        </span>

        <div class="flex md:landscape:gap-2 md4:landscape:gap-4 portrait:gap-4 items-center md:lanscape:mt-1 xl:landscape:mt-2 portrait:mt-2">
          <img src="assets/images/ic_angebote_active1x.png" class="w-14 h-14 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <div class="flex flex-col gap-0">
            <span class="font-semibold">Relevante Angebote</span>
            <span>{{ getContactEvent('OFFERS').customerDescription | stripHtml }}</span>
          </div>
        </div>

        <div class="flex md:landscape:gap-2 md4:landscape:gap-4 portrait:gap-4 items-center md:landscape:mt-1 lg:landscape:mt-2 xl:landscape:mt-4 portrait:mt-4">
          <img src="assets/images/ic_erinnerungen_active1x.png" class="w-14 h-14 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <div class="flex flex-col gap-0">
            <span class="font-semibold">Erinnerungen</span>
            <span>{{ getContactEvent('REMINDER').customerDescription | stripHtml }}</span>
          </div>
        </div>

        <div class="flex md:landscape:gap-2 md4:landscape:gap-4 portrait:gap-4 items-center md:landscape:mt-1 md3:landscape:mt-2 lg:landscape:mt-4 xl:landscape:mt-6 portrait:mt-6">
          <img src="assets/images/ic_events_active1x.png" class="w-14 h-14 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <div class="flex flex-col gap-0">
            <span class="font-semibold">Einladungen</span>
            <span>{{ getContactEvent('EVENTS').customerDescription | stripHtml }}</span>
          </div>
        </div>

        <div class="flex md:landscape:gap-2 md4:landscape:gap-4 portrait:gap-4 items-center md:landscape:mt-1 md3:landscape:mt-2 lg:landscape:mt-4 xl:landscape:mt-6 portrait:mt-6">
          <img src="assets/images/ic_befragungen_active1x.png" class="w-14 h-14 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <div class="flex flex-col gap-0">
            <span class="font-semibold">Befragungen</span>
            <span>{{ getContactEvent('SURVEYS').customerDescription | stripHtml }}</span>
          </div>
        </div>
      </div>

      <!-- CONTACT CHANNELS DESKTOP VIEW -->
      <div class="hidden md:block flex flex-col md:landscape:w-[20%] md:portrait:w-[25%] lg:w-[25%] bg-buttonsBar/60 rounded-2xl justify-start items-center">
        <div class="w-full flex justify-center items-center">
          <span class="font-semibold text-base md:portrait:text-base md:landscape:text-[10px] md:landscape:leading-[15px] md2:landscape:text-[11px] md:landscape:leading-[16px] md4:landscape:text-sm mlg:text-base mt-1">KONTAKTKANÄLE</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center md:landscape:mt-1 md4:landscape:mt-2 md:portrait:mt-2">
          <img src="assets/images/ic_post_active1x.png" class="w-6 h-6 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <span class="font-semibold">Post</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center md:landscape:mt-1 md4:landscape:mt-2 mlg:landscape:mt-4 md:portrait:mt-4">
          <img src="assets/images/ic_mail_active1x.png" class="w-6 h-6 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <span class="font-semibold">E-Mail</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center md:landscape:mt-1 md4:landscape:mt-2 mlg:landscape:mt-4 md:portrait:mt-4">
          <img src="assets/images/ic_phone_active1x.png" class="w-6 h-6 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <span class="font-semibold">Telefon</span>
        </div>

        <div class="flex flex-col gap-1 justify-center items-center md:landscape:mt-1 mb-1 md4:landscape:mt-2 mlg:landscape:mt-4 md:portrait:mt-4">
          <img src="assets/images/ic_messenger_active1x.png" class="w-6 h-6 md:landscape:w-6 md:landscape:h-6 md2:landscape:w-8 md2:landscape:h-8 md3:landscape:w-9 md3:landscape:h-9 md4:landscape:w-10 md4:landscape:h-10 lg:w-12 lg:h-12 mlg:w-14 mlg:h-14 md:portrait:w-14 md:portrait:h-14">
          <span class="font-semibold">Messenger / SMS</span>
        </div>
      </div>

      <!-- CONTACT CHANNELS MOBILE VIEW -->
      <div class="md:hidden flex flex-col w-full bg-buttonsBar/60 p-2 rounded-2xl justify-center items-center">
        <span class="font-semibold text-base">KONTAKTKANÄLE</span>

        <div class="flex w-full justify-between items-start mt-4 gap-1">
          <div class="flex flex-col gap-1 justify-center items-center w-full">
            <img src="assets/images/ic_post_active1x.png" class="w-14 h-14">
            <span class="font-semibold">Post</span>
          </div>

          <div class="flex flex-col gap-1 justify-center items-center w-full">
            <img src="assets/images/ic_mail_active1x.png" class="w-14 h-14">
            <span class="font-semibold">E-Mail</span>
          </div>

          <div class="flex flex-col gap-1 justify-center items-center w-full">
            <img src="assets/images/ic_phone_active1x.png" class="w-14 h-14">
            <span class="font-semibold">Telefon</span>
          </div>

          <div class="flex flex-col gap-1 justify-center items-center w-full min-w-[82px]">
            <img src="assets/images/ic_messenger_active1x.png" class="w-14 h-14">
            <span class="font-semibold text-center w-full">Messenger / SMS</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
